



















































import Vue from "vue";
import Component from 'vue-class-component';
import StarIcon from 'vue-material-design-icons/Star.vue';

@Component({
    components: { StarIcon },
    props: {
        item: {}
    }
})
export default class DetalhesPlano extends Vue {}
